import { soundService } from './services/soundService';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './services/apiAuthFetch';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// --- Smooth Update Transition (Clear Overly Mask) ---
(function clearUpdateMask() {
  localStorage.removeItem('libritui_updating');
  const overlay = document.getElementById('libritui-update-overlay');
  if (overlay) {
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.8s ease-out';
    overlay.style.pointerEvents = 'none';
    setTimeout(() => {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 1000);
  }
})();

// --- CRITICAL VERSION CHECK & HARD RESET ---
const CURRENT_VERSION_STR = process.env.APP_VERSION || '0';
// Extract numerical part if version is like 'v1.2.5' or just timestamp
const getVersionScore = (v: string) => parseInt(v.replace(/\D/g, '')) || 0;

const CURRENT_VERSION_SCORE = getVersionScore(CURRENT_VERSION_STR);
const STORED_VERSION_STR = localStorage.getItem('app_version') || '0';
const STORED_VERSION_SCORE = getVersionScore(STORED_VERSION_STR);

// Cooldown logic: Don't hard reset more than once per hour
const LAST_RESET_TIME = parseInt(localStorage.getItem('last_hard_reset') || '0');
const ONE_HOUR = 60 * 60 * 1000;
const IS_COOLDOWN_ACTIVE = Date.now() - LAST_RESET_TIME < ONE_HOUR;

if (CURRENT_VERSION_SCORE > STORED_VERSION_SCORE && !IS_COOLDOWN_ACTIVE) {
  console.warn(`[VersionCheck] New version available (${STORED_VERSION_STR} -> ${CURRENT_VERSION_STR}). Preparing reset...`);
  
  const performHardReset = async () => {
    try {
      localStorage.setItem('last_hard_reset', Date.now().toString());
      localStorage.setItem('app_version', CURRENT_VERSION_STR);

      if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(
          names
            .filter(name => name !== 'whisper-stt-cache' && name !== 'nllb-onnx-models-v1' && name !== 'free-dict-cache' && name !== 'rich-dict-cache-v2' && name !== 'bergamot-models-v1' && name !== 'marian-onnx-models-v1' && name !== 'transformers-cache' && name !== 'piper-voices-cache')
            .map(name => caches.delete(name))
        );
      }
      
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(reg => reg.unregister()));
      }

      console.log('[VersionCheck] Hard reset complete. Reload required.');
      // window.location.reload(); // DESATIVADO TEMPORARIAMENTE conforme solicitado
    } catch (e) {
      console.error('[VersionCheck] Reset failed:', e);
    }
  };

  performHardReset();
} else if (!localStorage.getItem('app_version')) {
  localStorage.setItem('app_version', CURRENT_VERSION_STR);
}
// -------------------------------------------

// Clear force reload throttling count on successful boot
try {
  sessionStorage.removeItem('libritui_force_reload_count');
} catch (e) {}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

soundService.init();
